import NoneFactoringStatus from "features/main/HaulPay/Status/None";
import { useUserFeature } from "hooks/useUserFeature";
import LoadPostedList from "../All";

export default function HaulPayLoads() {
  const { isFactoringApproved } = useUserFeature();

  if (isFactoringApproved === "") return <NoneFactoringStatus />;
  return <LoadPostedList is_haulpay />;
}
